export const data = [
  {
    value: 'topicId',
    title: 'Engagement',
    children: [
      {
        value: 'staticId1',
        title: 'i can see the positive impact',
      },
      {
        value: 'staticId2',
        title: 'i can see the positive impact2',
      },
    ],
  },
  {
    value: 'topicId2',
    title: 'Agility',
    children: [
      {
        value: 'staticId3',
        title: 'My managers see 1',
      },
    ],
  },
  {
    value: 'topicId3',
    title: 'Inclusion',
    children: [
      {
        value: 'staticId4',
        title: 'inclision Ques1',
      },
      {
        value: 'staticId5',
        title: 'inclusion Que 2',
      },
    ],
  },
];

export const ENGAGEMENT_DEFAULT = "engagement"
export const FUNCTIONAL_VP = "functional vp"
